import React, { useState, useEffect } from "react"
import { Modal, ModalHeader, ModalBody } from "reactstrap"

const Contact = ({ isOpen, lang, toggle }) => {
  return <>
    <Modal isOpen={isOpen} toggle={toggle} id="contact" className="contact">
      <ModalHeader className="pb-2" toggle={toggle}>{lang.contact_us.title}</ModalHeader>
      <ModalBody>
        <div className="row pt-2 contact">
          <div className="col-md-12 text">{lang.contact_us.description}</div>
          <div className="col-lg-4 col-md-4 col-sm-12 mt-5">
            <div className="border">
              <ul>
                <i className="fas fa-globe-asia icon"></i><br />
                {/* <br/> */}
                {/* <li className="bold">24/7 Worldwide Assistance </li>
                      <li>+603 7628 3860 / +603 7841 5770</li> */}
                <li className="bold mt-3">{lang.contact_us.helpline_01}</li>
                <li><a href="tel:1800188033">1800 18 8033</a></li>
                <li className="bold mt-3">{lang.contact_us.helpline_02}</li>
                <li><a href="tel:1300882323">1300 88 2323</a></li>
              </ul>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 mt-5">
            <div className="border">
              <ul>
                <i className="fas fa-headphones-alt icon"></i><br /><br />
                <li className="bold">{lang.contact_us2.customer_01}</li>
                <li>{lang.contact_us.customer_02}</li>
                <li><a href="tel:1800889933">1 800 889 933</a>{" (" + lang.contact_us.inMalaysia + ")"}</li>
                <li><a href="tel:+60321707300">+603 2170 7300</a>{" (" + lang.contact_us.oversea + ")"}</li>
                <li><a href="mailto:customer@bsompo.com.my">customer@bsompo.com.my</a></li>
                <br />
                <li className="bold">{lang.contact_us2.customer_03}</li>
                <li><a href="tel:+60362047788">+603 6204 7788</a>{" (" + lang.contact_us2.twentyfourhours + ")"}</li>
                <li><a href="mailto:contactus@cimb.com">contactus@cimb.com</a></li>
              </ul>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 mt-5">
            <div className="border">
              <ul>
                <i className="fas fa-map-marker-alt icon"></i><br /><br />
                <li className="bold">Berjaya Sompo Insurance Berhad<br />
                  {lang.contact_us.registration_no}</li>
                <li>Level 36, Menara Bangkok Bank,
                  105, Jalan Ampang,
                  50450 Kuala Lumpur</li>
              </ul>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  </>
}

export default Contact